module.exports = __webpack_public_path__ + "static/media/md-navigate.21ea8207.svg";